class TreeRootAccessor {
  /**
   * Whenever an update occurs, a new instance of this class is created.
   */
  constructor(hasUnpersistedChanges, isMutating, bindingOperations) {
    this.hasUnpersistedChanges = hasUnpersistedChanges;
    this.isMutating = isMutating;
    this.bindingOperations = bindingOperations;
  }
}
export {
  TreeRootAccessor
};
//# sourceMappingURL=TreeRootAccessor.js.map
